module.exports = __webpack_public_path__ + "img/zhjq13_image.2ec05499.png";